<template>
  <nuxt-link :to="'/'" class="border-none headerLogo" title="דרושים IL">
    <img src="https://s3.eu-west-1.amazonaws.com/assets.drushim.co.il/assets/Images/_logo.png" width="100%"  height="100%" alt="דרושים IL" />   
  </nuxt-link>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped>
a {
  width: 160px;
  margin-left: 25px;
}

@media screen and (max-width: 1280px) {
  .headerLogo {
    width: 160px;
    margin-left: 15px;
  }
}

@media screen and (max-width: 1160px) {
  .headerLogo {
    width: 135px;
    margin-left: 10px;
  }
}

@media screen and (max-width: 768px) {
  .headerLogo {
    padding-top: 0px;
    margin-left: 0;
  }
}

@media screen and (max-width: 480px) {
  .headerLogo {
    width: 110px;
    margin-left: 0;
    padding: 0;
  }
}
</style>
